import {
  COMPANY_PROFILE_ANY_FAILED,
  COMPANY_PROFILE_ANY_REQUEST,
  GET_COMPANY_ANSWERS_SUCCESS,
  GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS,
  GET_COMPANY_NEWS_SUCCESS,
  GET_COMPANY_QUESTIONS_SUCCESS,
  GET_COMPANY_TOPICS_SUCCESS,
} from '~src/modules/reports/companyProfile/constants/companyProfileActions';
import { reportingApi } from '~src/services/ApiController';

export const fetchCompanyTopicsList = (queryStr: string) => ({
  types: [COMPANY_PROFILE_ANY_REQUEST, GET_COMPANY_TOPICS_SUCCESS, COMPANY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/company/topics${queryStr}`),
});

export const fetchCompanyQuestionsList = (topicId: string, queryStr: string) => ({
  types: [COMPANY_PROFILE_ANY_REQUEST, GET_COMPANY_QUESTIONS_SUCCESS, COMPANY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/company/topic/${topicId}/questions${queryStr}`),
});

export const fetchCompanyQuestionsImproveList = (topicId: string, queryStr: string) => ({
  types: [COMPANY_PROFILE_ANY_REQUEST, GET_COMPANY_QUESTIONS_IMPROVE_SUCCESS, COMPANY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/company/topic/${topicId}/how-to-improve${queryStr}`),
});

export const fetchCompanyAnswersList = (questionId: string, queryStr: string) => ({
  types: [COMPANY_PROFILE_ANY_REQUEST, GET_COMPANY_ANSWERS_SUCCESS, COMPANY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/company/question/${questionId}/answers${queryStr}`),
});

export const fetchCompanyNewsList = (params?: string) => ({
  types: [COMPANY_PROFILE_ANY_REQUEST, GET_COMPANY_NEWS_SUCCESS, COMPANY_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/company/news?${params}`),
});
